/* eslint-disable @khan/frontend/require-stories -- TODO */
import * as React from "react";

// eslint-disable-next-line no-restricted-imports -- TODO
import * as Perseus from "@khanacademy/perseus";
import type {PropsFor} from "@khanacademy/wonder-blocks-core";

import {PerseusI18nProviderWrapper} from "./perseus-i18n-provider-wrapper.tsx";

export const ArticleRenderer = React.forwardRef<
    Perseus.ArticleRenderer,
    PropsFor<typeof Perseus.ArticleRenderer>
>((props: PropsFor<typeof Perseus.ArticleRenderer>, ref) => (
    <PerseusI18nProviderWrapper>
        <Perseus.ArticleRenderer {...props} ref={ref} />
    </PerseusI18nProviderWrapper>
));
